import { useEffect } from 'react';

export const useClickOutside = <T extends HTMLElement>(
    elementOrRefs: T | null | Array<React.RefObject<T>>,
    callback: () => void
) => {

    useEffect(() => {
        if (process.env.REACT_APP_TO_BUILD === 'website') {
            // Handle single element (backward compatibility)
            if (!Array.isArray(elementOrRefs)) {
                const element = elementOrRefs;
                
                const isOutsideRef = (target: Node) => {
                    return !element?.contains(target);
                };

                const onClick = (e: MouseEvent) => {
                    if (isOutsideRef(e.target as Node)) {
                        callback();
                    }
                };

                document.addEventListener('mousedown', onClick);
                return () => document.removeEventListener('mousedown', onClick);
            }
            
            // Handle multiple refs
            const refObjects = elementOrRefs;
            
            const isOutsideAllRefs = (target: Node) => {
                return refObjects.every(refObject => !refObject.current?.contains(target));
            };

            const onClick = (e: MouseEvent) => {
                if (isOutsideAllRefs(e.target as Node)) {
                    callback();
                }
            };

            document.addEventListener('mousedown', onClick);
            return () => document.removeEventListener('mousedown', onClick);
        }
    }, [callback, elementOrRefs]);
};